export const enableScreenshotMode = () => {
    document.body.classList.add('super-admin-hidden');
    document.dispatchEvent(new CustomEvent('screenshotmodeenabled'));
};
